import { Component, HostBinding, OnDestroy, OnInit } from '@angular/core';
import { LogCategory, LoggerService, LogType, LogWidget } from '../../core/services/logger.service';
import { ProfileService } from '../../core/services/profile.service';
import { CanvasService } from '../../services/canvas.service';
import { IWidgetComponent } from '../../shared/widget/i-widget-component';
import { Widget } from '../../shared/widget/widget';

@Component({
    selector: 'canvas-assignments',
    templateUrl: './canvas-assignments.component.html',
    styleUrls: ['./canvas-assignments.component.scss'],
    standalone: false
})
export class CanvasAssignmentsComponent implements OnInit, OnDestroy, IWidgetComponent {
    public data: Widget;

    @HostBinding('class')
    get size(): string {
        var widgetSize = 'col-md-' + this.data.Size.toString();

        switch (this.data.Size) {
            case 4: {
                widgetSize += ' widget-small';
                break;
            }
            case 6: {
                widgetSize += ' widget-medium';
                break;
            }
            case 12: {
                widgetSize += ' widget-large';
                break;
            }
        }

        return widgetSize;
    }

    constructor(
        public profile: ProfileService,
        private logger: LoggerService,
        public canvas: CanvasService
    ) {
        this.log("constructor", null, LogCategory.Constructor);
    }
    private log(method: string = null, message = null, category: LogCategory = LogCategory.Default): void {
        method = (method) ? '.' + method + '()' : '';
        message = (message) ? message.toString() : '';
        this.logger.try(this.constructor.name + method + ': ' + message, LogType.Widget, LogWidget.CanvasAssignments, category);
    }

    ngOnInit() {
        this.log("ngOnInit", null, LogCategory.Init);
    }

    ngOnDestroy() {
        this.log("ngOnDestroy", "", LogCategory.Destroy);
    }

    public getStatus(type: any): string {

        if (type) {
            switch (type) {
                case "grading":
                    return "Awaiting Grading";
                case "submitting":
                    return "Due Soon";                
                default:
                    return "";
            }
        }
        return "";
    }
}
